module.exports = __webpack_public_path__ + "static/media/blog-page-4.f9b5f932.jpg";